import React, { PureComponent } from 'react';
import T from 'prop-types';
import AdMarker from './components/ad-marker';
import MediaMarker from './components/media-marker';
import { MARKER_TYPES } from '../../../../../../shared/helpers/markers';
import { markerPropType } from '../../../../../../customPropTypes';

const selectSelectableMarkers = markers =>
  markers.filter(marker => marker.type !== MARKER_TYPES.AUDIO).sort((a, b) => a.start - b.start);

export default class Markers extends PureComponent {
  renderMarker = marker => {
    const { selectedMarkerId, ...restProps } = this.props;
    const markerProps = {
      ...restProps,
      marker,
      key: marker.id,
      selected: marker.id === selectedMarkerId,
    };

    if (marker.type === MARKER_TYPES.AD) {
      return <AdMarker {...markerProps} />;
    }

    return <MediaMarker {...markerProps} />;
  };

  render() {
    const selectableMarkers = selectSelectableMarkers(this.props.markers);

    return (
      <div className="editor-timeline__markers">{selectableMarkers.map(this.renderMarker)}</div>
    );
  }
}

Markers.propTypes = {
  selectedMarkerId: T.string,
  markers: T.arrayOf(markerPropType),
};

Markers.defaultProps = {
  markers: [],
};
